import React from 'react';

import { Typography } from 'pages/Students/shared';
import { colors } from 'theme/palette';

import Dialog from 'components/Dialog';

import styles from './styles.module.scss';

const CheckEmotionalStateDialog = ({ onClick }) => {
  const options = [
    { emoji: '🤩', label: 'Excited', value: 'excited' },
    { emoji: '😎', label: 'Confident', value: 'confident' },
    { emoji: '😐', label: 'Fine', value: 'fine' },
    { emoji: '😮‍💨', label: 'Stressed', value: 'stressed' },
    { emoji: '😡', label: 'Angry', value: 'angry' }
  ];

  return (
    <Dialog
      open
      showClose={false}
      onClose={() => {}}
      PaperProps={{
        className: styles.dialogPaper
      }}
    >
      <Typography
        variant="H-TEXT-3"
        color={colors.blue4}
        align="center"
        className={styles.submittedHeader}
      >
        How are you feeling about this assignment?
      </Typography>
      <div className={styles.options}>
        {options.map((option) => (
          <button
            key={option.label}
            onClick={() => onClick(option.value)}
            className={styles.option}
          >
            <span className={styles.emoji}>{option.emoji}</span>
            <span className={styles.label}>{option.label}</span>
          </button>
        ))}
      </div>
    </Dialog>
  );
};

export default CheckEmotionalStateDialog;
